import { render, staticRenderFns } from "./FileUploadConfigView.vue?vue&type=template&id=87431d7c&scoped=true&"
import script from "./FileUploadConfigView.vue?vue&type=script&lang=js&"
export * from "./FileUploadConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87431d7c",
  null
  
)

export default component.exports